import { Injectable } from "@angular/core";
import { UsersService } from "./user.service";
import { UserUtil } from "../utils/user.utils";
import { CookieService } from "ngx-cookie-service";
import { UserPreferencesService } from "./user-preferences.service";
import { UserNotification } from "../models/interfaces/user-notification.interface";
import { DeviceTypeEnum } from "../models/enum/device-type.enum";

@Injectable()
export class SignOutService {
    constructor(
        private readonly cookieService: CookieService,
        private readonly userPreferenceService: UserPreferencesService,
        private readonly usersService: UsersService,
        private readonly userUtil: UserUtil,
    ) { }

    async logout(): Promise<void> {
        await this.removeUserNotification();
        this.clearLocalSession();
    }

    private async removeUserNotification(): Promise<string | null> {
        const user = this.userUtil.getUser();
        const fcmToken = this.userUtil.getUserFcmToken();

        if (!user || !fcmToken) {
            return null;
        }

        const userNotification: UserNotification = {
            deviceType: DeviceTypeEnum.WEB,
            fcmToken,
        };

        try {
            return await this.usersService
                .removeUserNotificationV2(user.id, userNotification)
                .toPromise();
        } catch (error) {
            console.error('Erro ao remover notificação do usuário', error);
            return null;
        }
    }

    private clearLocalSession(): void {
        this.cookieService.deleteAll();
        this.userPreferenceService.clear();
        (window as any).Intercom?.('shutdown');
    }

}